module.exports = __webpack_public_path__ + "img/87.c94b3d8e.svg";